"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgComposeFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24 18.49V28H8V6h11.36l2-2H6v26h20V16.49l-2 2z" }),
        React.createElement("path", { d: "M26.9 3.37l-.48-.13L12 17.65V22h4.34L30.76 7.58l-.14-.48a5.76 5.76 0 00-3.72-3.73z", display: "#1d1d1b" }),
        React.createElement("path", { d: "M16.34 22H12v-4.35L26.42 3.24l.48.13a5.76 5.76 0 013.72 3.73l.14.48z" })));
}
exports.default = SvgComposeFilled;
//# sourceMappingURL=ComposeFilled.js.map